module.exports = __webpack_public_path__ + "img/usb_300.518dc620.png";